import PerformerProjects from '@/views/performer/PerformerProjects.vue';
import PerformerProject from '@/views/performer/form/PerformerProjectForm.vue';
import PerformerProjectTasks from '@/views/performer/tasks/PerformerProjectTasks.vue';
import PerformerTasks from '@/views/performer/PerformerTasks.vue';
import { USER_ROLE_PERFORMER } from '@/api/models/UserRole';

const role = USER_ROLE_PERFORMER;

export const performerRoutes = [
  {
    path: '/performer/tasks',
    name: 'performer-tasks',
    hash: '#inwork',
    component: PerformerTasks,
    meta: { requiresAuth: true, type: 'tasks', role: role },
  },
  {
    path: '/performer/project/:id/tasks',
    name: 'performer-project-tasks',
    component: PerformerProjectTasks,
    meta: { requiresAuth: true, type: 'projects', role: role },
  },
  {
    path: '/performer/projects',
    name: 'performer-projects',
    hash: '#inwork',
    component: PerformerProjects,
    meta: {
      requiresAuth: true,
      type: 'projects',
      role: role,
      default: true,
    },
  },
  {
    path: '/performer/project/:id/form',
    name: 'performer-project-form',
    component: PerformerProject,
    meta: { requiresAuth: true, type: 'projects', role: role },
  },
];
